import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Preloader from "../helper/Preloader";

const Privacy = () => {
  const { t, i18n } = useTranslation();

  // Get sections as objects (similar to tm(...) in Vue)
  const sections = useMemo(() => {
    const s = t("privacy_content.sections", { returnObjects: true });
    return Array.isArray(s) ? s : [];
  }, [t, i18n.language]);

  const getPoint = (i, j) => sections?.[i]?.points?.[j];

  const isNestedPoint = (i, j) => {
    const p = getPoint(i, j);
    return p && typeof p === "object" && Array.isArray(p.children);
  };

  const hasSubtitle = (i) => {
    const key = `privacy_content.sections.${i}.subtitle`;
    if (!i18n.exists(key)) return false;
    const val = t(key);
    return String(val).trim().length > 0;
  };

  return (
    <>
      {/* Preloader (adapt to your real loading condition if needed) */}
      <Preloader />
      <div className="privacy-policy">
        <div className="container container-full">
          {/* Page title */}
          <h3 className="privacy__text" style={{ textAlign: "center" }}>
            {t("privacy_content.page_title")}
          </h3>

          {/* Page intro message */}
          <p className="font-18 privacy__text">
            {t("privacy_content.page_message")}
          </p>

          {/* Sections */}
          <div>
            {sections.map((section, i) => (
              <div className="privacy-policy__wrap" key={i}>
                {/* Section title */}
                <h5 className="privacy__text">
                  {t(`privacy_content.sections.${i}.title`)}
                </h5>

                {/* Optional subtitle */}
                {hasSubtitle(i) && (
                  <p className="font-16 privacy__text">
                    {t(`privacy_content.sections.${i}.subtitle`)}
                  </p>
                )}

                {/* Section points */}
                <ul className="privacy-policy__list">
                  {(section.points || []).map((_p, j) => (
                    <li key={j} className="privacy-policy__item">
                      {isNestedPoint(i, j) ? (
                        <>
                          {/* Parent text */}
                          <p className="font-16 privacy__text">
                            {t(
                              `privacy_content.sections.${i}.points.${j}.text`
                            )}
                          </p>
                          {/* Children list */}
                          <ul className="privacy-policy__sublist">
                            {getPoint(i, j).children.map((_c, k) => (
                              <li key={k} className="privacy-policy__subitem">
                                <p className="font-16 privacy__text">
                                  {t(
                                    `privacy_content.sections.${i}.points.${j}.children.${k}`
                                  )}
                                </p>
                              </li>
                            ))}
                          </ul>
                        </>
                      ) : (
                        <p className="font-16 privacy__text">
                          {t(`privacy_content.sections.${i}.points.${j}`)}
                        </p>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Privacy;
